import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { Observable, map } from 'rxjs';
import { ApiService } from '@app/shared/api/api.service';
import { ApiResponse } from '@app/shared/api/model/api.model';
import { PagedResponse } from '@app/features/users/core/user.model';
import { appendParamsFromObject } from '@app/shared/utils/object.utils';
import {
  EndImpersonationResponse,
  SearchSupportSessionsRequest,
  StartImpersonationRequest,
  StartImpersonationResponse,
  SupportSessionResponse,
} from './support-session.model';

@Injectable({
  providedIn: 'root',
})
export class SupportSessionApiService {
  private readonly impersonationPath = '/support/impersonation';
  private readonly sessionsPath = '/support/sessions';

  constructor(private apiService: ApiService) {}

  startImpersonation(
    request: StartImpersonationRequest,
  ): Observable<StartImpersonationResponse> {
    return this.apiService
      .post<ApiResponse<StartImpersonationResponse>>({
        path: `${this.impersonationPath}/start`,
        body: request,
      })
      .pipe(map((response) => response.data));
  }

  endImpersonation(): Observable<EndImpersonationResponse> {
    return this.apiService
      .post<ApiResponse<EndImpersonationResponse>>({
        path: `${this.impersonationPath}/end`,
        body: {},
      })
      .pipe(map((response) => response.data));
  }

  searchSessions(
    query?: SearchSupportSessionsRequest,
  ): Observable<PagedResponse<SupportSessionResponse>> {
    let params = new HttpParams();
    if (query) {
      params = appendParamsFromObject(params, query);
    }

    return this.apiService
      .get<ApiResponse<PagedResponse<SupportSessionResponse>>>({
        path: this.sessionsPath,
        options: { params },
      })
      .pipe(map((response) => response.data));
  }
}
